'use client';

import { useEffect, type ReactNode } from 'react';
import { isSignupPagePathname } from '../off-path-pages';
import { leaveSignupFlow } from '../stores/signup-flow-store';

/**
 * Wraps every signup page (rendered by the signup layout, which stays mounted
 * while the member moves between signup pages). When it unmounts because the
 * member went to another part of the app, the flow is abandoned and its
 * answers are cleared. The check waits for the route change to settle and
 * reads where the browser now is, so moving between signup pages, or a
 * StrictMode remount, clears nothing.
 */
export function SignupAreaBoundary({ children }: { children: ReactNode }) {
  useEffect(
    () => () => {
      setTimeout(() => {
        if (!isSignupPagePathname(window.location.pathname)) leaveSignupFlow();
      }, 0);
    },
    [],
  );
  return children;
}
